import { LAST_PATH_STORAGE_KEY } from './constants';

/**
 * Set the last visited venue path in localStorage
 */
export const setLastPathCookie = (path: string): void => {
  try {
    // Make sure we have a valid path
    if (!path) {
      console.error('Missing path for localStorage');
      return;
    }

    localStorage.setItem(LAST_PATH_STORAGE_KEY, path);
  } catch (error: unknown) {
    console.error('Error setting path in localStorage:', error);
  }
};
